import { render, staticRenderFns } from "./UsedSpecial.vue?vue&type=template&id=82531524&scoped=true&"
import script from "./UsedSpecial.vue?vue&type=script&lang=js&"
export * from "./UsedSpecial.vue?vue&type=script&lang=js&"
import style0 from "./UsedSpecial.vue?vue&type=style&index=0&id=82531524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82531524",
  null
  
)

export default component.exports